import { render } from "./IconAttachment.vue?vue&type=template&id=21c0bd94"
import script from "./IconAttachment.vue?vue&type=script&lang=js"
export * from "./IconAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/16/IconAttachment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21c0bd94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21c0bd94', __exports__)) {
    api.reload('21c0bd94', __exports__)
  }
  
  module.hot.accept("./IconAttachment.vue?vue&type=template&id=21c0bd94", () => {
    api.rerender('21c0bd94', render)
  })

}


export default __exports__